import { Component, ChangeDetectionStrategy } from '@angular/core';
import { JobGalleryComponent } from "./job-gallery/job-gallery.component";
import { SOCIAL_LINK_LINKEDIN } from '../../shared/constants';

@Component({
    selector: 'app-careers',
    imports: [JobGalleryComponent],
    templateUrl: './career.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './career.component.scss'
})
export class CareersComponent {
  SOCIAL_LINK_LINKEDIN: string = SOCIAL_LINK_LINKEDIN
}
